import React from "react";
import { Grid, Alert } from "@mui/material";
import {
    StyledContainer,
    StyledTypography,
} from "components/Screens/Company/CompanySummary";

// Sub-components
import ThesisPillarsSection from "./components/ThesisPillarsSection";
import VotingSection from "./components/VotingSection";
import RecentUpdatesSection from "./components/RecentUpdatesSection";
import MeetingHistorySection from "./components/MeetingHistorySection";
import KeyDebatesSection from "./components/KeyDebatesSection";

// Types
import { CompanySummary, SummaryVoting } from "./types";

interface Props {
    summary: CompanySummary;
}

export const CompanySummaryContent: React.FC<Props> = ({ summary }) => {
    if (!summary) {
        return <Alert severity="info">No summary data available.</Alert>;
    }

    return (
        <StyledContainer px={{ xs: 1, md: 2 }} py={2}>
            <Grid
                container
                sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    pb: 2,
                    mb: 3,
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <StyledTypography
                    variant="h4"
                    color="primary"
                    fontWeight="bold"
                    sx={{
                        fontSize: { xs: "1.5rem", md: "2rem" },
                    }}
                >
                    {summary.company_name}
                </StyledTypography>
            </Grid>

            <Grid container spacing={{ xs: 2, md: 3 }}>
                {/* Thesis Pillars */}
                <Grid item xs={12}>
                    <ThesisPillarsSection
                        thesisPillars={summary.thesis_pillars}
                    />
                </Grid>

                {/* BQ and MQ Voting */}
                <Grid item xs={12} md={6}>
                    <VotingSection
                        votingData={summary.voting_bq as SummaryVoting}
                        title="BQ"
                        type="BQ"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <VotingSection
                        votingData={summary.voting_mq as SummaryVoting}
                        title="MQ"
                        type="MQ"
                    />
                </Grid>

                {/* Key Debates */}
                <Grid item xs={12}>
                    <KeyDebatesSection keyDebates={summary.key_debates} />
                </Grid>

                {/* Recent Updates */}
                <Grid item xs={12}>
                    <RecentUpdatesSection
                        recentUpdates={summary.recent_updates_markdown}
                    />
                </Grid>

                {/* Meeting History Chart */}
                <Grid item xs={12}>
                    <MeetingHistorySection
                        meetingNotes={summary.meeting_notes_summaries}
                        companySectorName={summary.company_sector_name}
                    />
                </Grid>
            </Grid>
        </StyledContainer>
    );
};
